import React, { useEffect, useState } from 'react';
import VerificationPopup from './modals/VerificationPopup';
import styles from '../styles/newFeature.module.css';
import content from '../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from './qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from './Industry/FAQ_mobile';
import FrequentQuestions from './homePage/FrequentQuestions';
import MobilePDBanner from './common/MobilePDBanner';
import PersonalisedDemoBanner from './common/PersonalisedDemoBanner';
import TestimonialSection from './common/TestimonialSection';
import MobileTestimonialSection from './common/MobileTestimonialSection';
import ThreeStepForm from './common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from './common/OutletFeatures';
import { MobileOurPartners } from './homePage/MobileOurPartners';
import { OurPartners } from './homePage/OurPartners';
import { useRouter } from 'next/router';

const DistributorPOS = () => {
    const router = useRouter()
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/distributorPOS/billingImage.webp",
            tag: "Billing",
            // icon: "/assets/outlet/iceCreamOutlet/posIcon.svg",
            title: "Billing",
            desc: "QueueBuster’s billing module is designed to streamline the sales process with a highly configurable interface, ensuring accuracy and efficiency in every transaction. The system prompts users about expiry or near-expiry items at the time of billing, helping to avoid potential losses. It also supports multiple price lists and batch-wise free schemes, allowing for flexible pricing and promotional strategies.",
            stack3Clr: "#fff6e1",
            stack2Clr: "#FFE9B6",
            stack1Clr: "#ffe097",
            borderColor: "#ffba00",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            btnText: "Contact Sales",
            point: [
                <>
                    Alerts users if product margins go negative with a red color indicator during billing.
                </>,
                <>
                    Displays the last rate charged and sale history prompts during sales returns.
                </>,
                <>
                    Supports areawise billing for precise customer selection and vanwise sale/dispatch management.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/distributorPOS/purchaseImage.webp",
            title: "Purchase",
            desc: "QueueBuster distribution software allows businesses to buy in cases and sell in dozens or pieces, accommodating multiple units of conversion. It provides suppliers defaults for discounts, schemes, and rates, ensuring that purchasing terms are consistently applied. The system can generate landing costs based on user-defined formulas and issue scheme alerts during purchases from the same supplier. ",
            stack1Clr: "#A1F3FF",
            stack2Clr: "#C2F7FF",
            stack3Clr: "#E2FBFF",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            btnText: "Contact Sales",
            borderColor: "#A1F3FF",
            point: [
                <>
                    Automatically emails orders to suppliers and allows the import of purchases from external files.
                </>,
                <>
                    Generates scheme debit notes based on sales targets set by the company.
                </>,
                <>
                    Provides detailed tracking of purchase returns and pending vouchers against suppliers.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/distributorPOS/inventoryImage.webp",
            title: "Inventory Management",
            desc: "QueueBuster’s inventory distribution management system offers comprehensive features to maintain accurate stock levels. It supports batch-wise and MRPwise stock tracking, import of item masters from Excel, and customized barcode generation. The system effectively manages expired and damaged stock and maintains bin/racks and godownwise inventory.",
            stack1Clr: "#E3B8FD",
            stack2Clr: "#EFD5FF",
            stack3Clr: "#F8ECFF",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            btnText: "Talk	to an expert",
            borderColor: "#E3B8FD",
            point: [
                <>
                    Provides detailed reports on dead and slow-moving stock for better inventory decisions.
                </>,
                <>
                    Supports the import of item masters from Excel, streamlining the inventory setup process.
                </>,
                <>
                    Enables fully customized barcode generation for efficient stock tracking and management.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/distributorPOS/reportingImage.webp",
            title: "Reporting",
            desc: "QueueBuster offers a robust reporting module with preconfigured templates and configurable reports and dashboards. The mobile reporting app allows users to access reports on the go, while the autoreport mailer ensures timely email delivery of reports. The system supports export to various formats like Excel, HTML, and PDF, providing flexibility in report handling.",
            stack3Clr: "#D6FFF5",
            stack2Clr: "#B7F8E7",
            stack1Clr: "#8EF4DA",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            btnText: "Contact Sales",
            borderColor: "#8EF4DA",
            point: [
                <>
                    Features effective coverage reports and top-to-bottom analysis of party/itemwise sales
                </>,
                <>
                    Provides target vs. achievement reports and delivery manwise reports for performance tracking.
                </>,
                <>
                    Offers comprehensive bitwise operations and outstanding reports with days breakup analysis.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/distributorPOS/accountingImage.webp",
            title: "Accounting & Financial Management",
            desc: "QueueBuster’s accounting and financial management module is simple yet highly configurable. It supports journal entries, cash/bank vouchers, and bills receivables/payables. The system includes cost centers, balance sheets, P&L, ratio analysis, and GST e-filing capabilities. Users can generate EWay bills, print cheques, and manage TDS/TCS. ",
            stack3Clr: "#FFF3F3",
            stack2Clr: "#FFCCCC",
            stack1Clr: "#FF9999",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            btnText: "Contact Sales",
            borderColor: "#FF9999",
            point: [
                <>
                    Facilitates the generation and management of postdated cheques (receipts/payments).
                </>,
                <>
                    Provides GST summary and autoentry of GST payable with journal entries.
                </>,
                <>
                    Includes a detailed module for TDS/TCS management and cheque printing.
                </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the key benefits of using the QueueBuster Wholesale Distribution POS System?
                </span>
            ),
            des: "The QueueBuster Wholesale Distribution POS System offers a multitude of benefits that significantly enhance the operational efficiency and productivity of wholesale and distribution businesses. The system streamlines the billing process with a highly configurable interface, ensuring quick and accurate transactions while providing alerts for expiry or near-expiry items, preventing potential losses. The comprehensive inventory management capabilities support batch-wise and MRP-wise stock tracking, along with the management of expired and damaged stock, and detailed reporting on dead and slow-moving inventory. Enhanced reporting capabilities include preconfigured templates, customizable reports and dashboards, and a mobile reporting app that allows users to access critical data on the go, while the auto-report mailer ensures timely email updates. The system also improves purchase management by accommodating multiple units of conversion, applying supplier defaults for discounts, schemes, and rates, and generating landing costs and scheme alerts during purchases. Furthermore, the QueueBuster system offers efficient accounting and financial management with support for journal entries, cash/bank vouchers, bills receivables/payables, cost centers, balance sheets, P&L, ratio analysis, and GST e-filing capabilities, providing a comprehensive financial management solution.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster’s billing module improve the sales process?
                </span>
            ),
            des: "Billing with QB significantly improves the sales process by providing a highly configurable interface that allows businesses to tailor the billing system to their specific needs, ensuring transactions are processed both accurately and efficiently. The system includes alerts for expiry or near-expiry items during billing, which helps to prevent potential losses. Additionally, the billing module supports multiple price lists and batch-wise free schemes, enabling flexible pricing and promotional strategies that can be customized to meet business requirements. The inclusion of features such as area-wise billing for precise customer selection and van-wise sale/dispatch management further enhances the efficiency of the sales process. Moreover, the system offers functionalities like displaying the last rate charged, sale history prompts during sales returns, and alerts if product margins go negative, all of which contribute to a streamlined and effective sales operation.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster’s purchase management module benefit my business?
                </span>
            ),
            des: "QueueBuster’s purchase and distribution management offers several benefits that enhance the procurement process and ensure consistency in purchasing terms. The system allows businesses to buy in cases and sell in dozens or pieces, accommodating multiple units of conversion. It provides supplier defaults for discounts, schemes, and rates, ensuring that purchasing terms are consistently applied across all transactions. The system can also generate landing costs based on user-defined formulas and issue scheme alerts during purchases from the same supplier, optimizing procurement strategies. Furthermore, it supports the automatic emailing of orders to suppliers and the import of purchase data from external files, streamlining the purchasing workflow. The module also generates scheme debit notes based on sales targets set by the company and provides detailed tracking of purchase returns and pending vouchers against suppliers, ensuring efficient management of the procurement process.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What inventory management features does QueueBuster offer?
                </span>
            ),
            des: "QB POS distribution system offers a comprehensive inventory management system designed to maintain accurate stock levels and streamline inventory operations. The system supports batch-wise and MRP-wise stock tracking, allowing businesses to manage their inventory more effectively. It also includes features for the import of item masters from Excel and fully customized barcode generation, facilitating efficient stock tracking and management. The inventory management system effectively handles expired and damaged stock and maintains bin/rack-wise and godown-wise inventory, ensuring that stock is organized and easily accessible. Additionally, QueueBuster provides detailed reports on dead and slow-moving stock, enabling businesses to make informed decisions about inventory management and reduce waste. These features collectively contribute to an efficient and effective inventory management process that supports business growth and operational efficiency.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster’s reporting module enhance business operations?
                </span>
            ),
            des: "Our POS reporting module significantly enhances business operations by providing robust and comprehensive reporting capabilities. The module includes preconfigured templates and customizable reports and dashboards, allowing businesses to generate reports that meet their specific needs. The mobile reporting app ensures that users can access critical data on the go, providing flexibility and convenience. The auto-report mailer feature delivers timely email updates, ensuring that key stakeholders are always informed. The system supports export to various formats such as Excel, HTML, and PDF, offering flexibility in report handling and distribution. Additionally, QueueBuster’s reporting module includes features like effective coverage reports, top-to-bottom analysis of party/item-wise sales, target vs. achievement reports, delivery man-wise reports, and comprehensive beat-wise operations and outstanding reports with days breakup analysis. These features provide valuable insights into business performance and support data-driven decision-making.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster’s accounting and financial management module support my business?
                </span>
            ),
            des: "The Online Ticket Booking feature of the QueueBuster Temple POS Solution offers numerous benefits for both devotees and temple management when it comes to organizing events and festivals. For devotees, this feature provides a convenient and secure way to book tickets for special darshans, festivals, and other temple events. They can select from available time slots, make payments online, and receive instant confirmation, all from the comfort of their homes.For temple management, this feature significantly reduces the administrative workload associated with event planning. It provides real-time data on ticket sales and attendance, allowing temple authorities to better plan and manage events. This information can be used to control crowds, allocate resources more effectively, and ensure that all attendees have a positive experience. The system also automates many aspects of the ticketing process, such as generating and sending tickets, which further reduces the burden on temple staff. By streamlining ticket sales and event management, the Online Ticket Booking feature helps to enhance the overall efficiency of temple operations and improve the experience for devotees.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster handle multi-location inventory management?
                </span>
            ),
            des: "This robust inventory distribution software effectively handles multi-location inventory management by providing a centralized system that offers real-time visibility and control over inventory levels across all locations. The system supports batch-wise and MRP-wise stock tracking, ensuring accurate inventory management at each location. It also allows for the import of item masters from Excel and customized barcode generation, facilitating efficient stock tracking and management. QueueBuster’s inventory management system maintains bin/rack-wise and godown-wise inventory, ensuring that stock is organized and easily accessible at all locations. Additionally, the system provides detailed reports on dead and slow-moving stock, enabling businesses to make informed decisions about inventory management and reduce waste. By offering a comprehensive and centralized solution for multi-location inventory management, QueueBuster helps businesses maintain optimal stock levels and streamline inventory operations across all locations.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster’s POS system integrate with other business applications?
                </span>
            ),
            des: "QueueBuster’s POS system is designed to integrate seamlessly with other business applications, promoting a cohesive and efficient business ecosystem. The system offers integration capabilities with various business applications, including accounting software, CRM systems, and e-commerce platforms. This ensures a seamless flow of data across different systems, enhancing overall business efficiency and accuracy. Integration with accounting software allows for the automatic synchronization of financial data, reducing manual data entry and minimizing errors. Integration with CRM systems enables businesses to manage customer data more effectively and personalize marketing strategies. Integration with e-commerce platforms supports unified inventory management and order processing, providing a seamless shopping experience for customers. By offering robust integration capabilities, QueueBuster helps businesses streamline their operations and improve overall productivity.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of support does QueueBuster offer for its POS system?
                </span>
            ),
            des: "QueueBuster provides dedicated customer support to ensure that users can navigate the POS system efficiently and resolve any issues that may arise. The support team is available to assist with queries, technical issues, and training requirements, ensuring that businesses can fully utilize the system's features. QueueBuster offers comprehensive training resources, including user manuals, video tutorials, and webinars, to help users understand and make the most of the system. The support team is accessible through multiple channels, including phone, email, and live chat, providing timely and effective assistance. Additionally, QueueBuster offers regular updates and enhancements to the system, ensuring that users have access to the latest features and improvements. By providing robust support and training, QueueBuster ensures that businesses can maximize the benefits of their POS system and maintain efficient operations.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster handle GST compliance and e-invoicing?
                </span>
            ),
            des: "QueueBuster ensures GST compliance and efficient e-invoicing through its comprehensive accounting and financial management module. The system includes GST e-filing capabilities, allowing businesses to generate and file GST returns accurately and on time. It supports the generation of E-Way bills and the management of TDS/TCS, ensuring compliance with regulatory requirements. The system also includes functionalities for journal purchase/debit note entry and sale/credit note entry HSN-wise, providing detailed financial tracking and reporting. Additionally, QueueBuster facilitates the auto-entry of GST payable through journal entries and provides a GST summary, helping businesses manage their tax obligations effectively. By offering robust GST compliance and e-invoicing capabilities, QueueBuster helps businesses streamline their tax processes and maintain compliance with regulatory standards.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
             {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/distributorPOS/distributorMobileImage.webp')" }}>
                        <div>
                            <h1>
                                <span>Upsell and Scale<br />With QB Wholesale</span><span></span>
                                <span>&nbsp; Distribution POS System</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "30rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>QueueBuster offers a robust wholesale POS system designed to increase productivity at the sales counter and in the warehouse. The intuitive interface allows for faster sales and service while providing real-time data access and order process improvements. With QueueBuster’s Wholesale and Distribution POS System, ensuring proper documentation and tracking for efficient inventory management becomes seamless, contributing to improved operational efficiency and customer satisfaction.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4.3rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/distributorPOS/distributorImage.webp"
                            heading={<>Upsell and Scale<br />With QB Wholesale{" "}</>}
                            staticHeading={<>Distribution POS System</>}
                            description={"QueueBuster offers a robust wholesale POS system designed to increase productivity at the sales counter and in the warehouse. The intuitive interface allows for faster sales and service while providing real-time data access and order process improvements. With QueueBuster’s Wholesale and Distribution POS System, ensuring proper documentation and tracking for efficient inventory management becomes seamless, contributing to improved operational efficiency and customer satisfaction."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "63%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.cards_section}>
                {features?.map((ele) => <StackContainers ele={ele} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={mobileView} />)}
            </div>

            {
                mobileView ? <MobileOurPartners title={"Partners and Integrations"} /> : <div style={{ marginTop: "10rem" }}><OurPartners title={"Partners and Integrations"} /></div>
            }

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions for QB Wholesale Distribution POS Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions for QB Wholesale Distribution POS Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default DistributorPOS